// extracted by mini-css-extract-plugin
module.exports = {"container":"IFIWq","row":"_3cbhm","column":"_2yBTk","iconColumn":"HrtdX"};